// extracted by mini-css-extract-plugin
export var accordionToggle = "CustomAccordion-module__accordionToggle___MAdVl";